const { CSendingTypesGenerallyAvailable } = require('@sigmasms/commons')
const { ESendingReplacementFields, ESendingSource } = require('@sigmasms/shared-types/services/Sendings/enums')
const { ESendingReplacementApplyOriginalContentFields } = require('@sigmasms/shared-types/services/Sendings/enums/SendingReplacementApplyOriginalContentFields.enum')
const { upgradeArray } = require('../utils')
const enumToConstant = require('../utils/enumToConstant')

const SENDING_STATUS = upgradeArray([ 'pending', 'paused', 'processing', 'sent', 'delivered', 'seen', 'failed' ])
const SENDING_TYPES = upgradeArray(CSendingTypesGenerallyAvailable) // Бэкап ниже в этом файле

// max length = 5
const SENDING_TYPES_SHORT = {
  sms: 'sms',
  smsping: 'smsp',
  mms: 'mms',
  viber: 'viber',
  voice: 'voice',
  whatsapp: 'wa',
  email: 'email',
  vk: 'vk',
  ok: 'ok',
  push: 'push',
  telegram: 'tg',
  facebook: 'fb',
  instagram: 'inst',
  whatsappchat: 'wacht',
  viberchat: 'vbcht',
  vkchat: 'vkcht',
  telegramchat: 'tgcht',
  facebookchat: 'fbcht',
  flashcall: 'fc',
  telegramcode: 'tgc'
}

const SENDING_SOURCES = upgradeArray(Object.keys(ESendingSource))
const SENDING_DIRECTIONS = upgradeArray([ 'inbound', 'outbound' ])
const SENDING_HASHABLE_FIELDS = upgradeArray([ 'payload', 'type' ])
const SENDING_PAYLOADS = {
  [SENDING_TYPES.sms]: [ 'recipient', 'sender', 'text' ],
  [SENDING_TYPES.vk]: [ 'recipient', 'sender', 'text', 'buttons' ],
  [SENDING_TYPES.ok]: [ 'recipient', 'sender', 'text', 'buttons' ],
  [SENDING_TYPES.mms]: [ 'recipient', 'sender', 'text', 'image' ],
  [SENDING_TYPES.viber]: [ 'recipient', 'sender', 'text', 'button.text', 'button.url', 'image' ],
  [SENDING_TYPES.whatsapp]: [ 'recipient', 'sender', 'text', 'buttons', 'image', 'file' ],
  [SENDING_TYPES.voice]: [ 'recipient', 'sender', 'text', 'audio', 'tts' ],
  [SENDING_TYPES.whatsappchat]: [ 'recipient', 'sender', 'text', 'button.text', 'button.url', 'image' ],
  [SENDING_TYPES.viberchat]: [ 'recipient', 'sender', 'text', 'button.text', 'button.url', 'image' ],
  [SENDING_TYPES.vkchat]: [ 'recipient', 'sender', 'text', 'button.text', 'button.url', 'image' ],
  [SENDING_TYPES.telegramchat]: [ 'recipient', 'sender', 'text', 'button.text', 'button.url', 'image' ],
  [SENDING_TYPES.flashcall]: [ 'recipient', 'sender', 'text' ],
  [SENDING_TYPES.push]: [ 'recipient', 'sender', 'text' ],
  [SENDING_TYPES.email]: [ 'recipient', 'sender', 'senderEmail', 'subject', 'text' ],
  [SENDING_TYPES.telegramcode]: [ 'recipient', 'sender', 'text' ]
}

const SENDING_REPLACEMENT_FIELDS = enumToConstant(ESendingReplacementFields)
const SENDING_REPLACEMENT_APPLY_ORIGINAL_CONTENT_FIELDS = enumToConstant(ESendingReplacementApplyOriginalContentFields)

module.exports = {
  SENDING_STATUS,
  SENDING_TYPES,
  SENDING_SOURCES,
  SENDING_DIRECTIONS,
  SENDING_HASHABLE_FIELDS,
  SENDING_PAYLOADS,
  SENDING_TYPES_SHORT,
  SENDING_REPLACEMENT_FIELDS,
  SENDING_REPLACEMENT_APPLY_ORIGINAL_CONTENT_FIELDS
}

// const SENDING_TYPES = upgradeArray([
//   'sms',
//   'smsping', // нету
//   'mms', // почти нету
//   'viber',
//   'voice',
//   'whatsapp',
//   'email', // нету
//   'vk',
//   'ok',
//   'push',
//   'telegram', // нету
//   'facebook', // нету
//   'instagram', // нету
//   'whatsappchat',
//   'viberchat',
//   'vkchat',
//   'telegramchat',
//   'facebookchat',
//   'flashcall',
//   'telegramcode'
// ])
